import React from 'react';

import { Bridge } from '@biw/bridge';

import { auth } from 'app/config';

interface Props {
    children?: any;
    requiresAuth: boolean;
    setUserData: (user: any) => any;
    initializeRouter: (userData: any) => any;
    isLoggedIn: boolean;
}

export default class AppAuth extends React.Component<Props> {
    public static defaultProps = {
        isLoggedIn: true,
        requiresAuth: false,
    };

    public onError = (error: any) => console.error( error );

    public handleLoaded = ( userData: any ) => {
        this.props.initializeRouter( userData );
    }

    public render() {
        const { setUserData, children, requiresAuth, isLoggedIn } = this.props;

        return (
            <Bridge
                requiresAuth={requiresAuth && !isLoggedIn}
                auth={auth}
                onError={this.onError}
                onSignIn={this.handleLoaded}
                onRefresh={this.handleLoaded}
                onSignOut={setUserData}
            >
                {children}
            </Bridge>
        );
    }
}
